import { Component, OnInit } from '@angular/core';
import { Channel } from 'src/app/models/Channel';
import { ChannelService } from 'src/app/services/Channel/Channel.service';
import { ToastrService } from "ngx-toastr";

@Component({
    selector: 'app-listchannel',
    templateUrl: './listchannel.component.html',
    styleUrls: ['./listchannel.component.scss'],
    standalone: false
})
export class ListChannelComponent implements OnInit {
  public channelList = Array<any>();
  constructor(private channelService: ChannelService,private toastr: ToastrService) {
    this.Get();
  }

  ngOnInit(): void {
     
  }


  public Get(){
    this.channelService.GetChannel().subscribe(response=>{
      this.channelList = response.Data;
    })
  }
 
  /**
     * Collect ID property from selected records and send it as an ARRAY
     * @param confirmText used for confirmation text
     * @param customDeleteID used for different ID
     */
   public Delete() {
     
    if (confirm("Are you sure you want to delete selected record/s?") == false)
        return;

    // filter selected data
    const listSelected = this.getSelectedData();

    if (listSelected.length > 0) {
        this.channelService.Delete(listSelected).subscribe(response=>{
          this.Get();
          this.toastr.success(response.Message,"Information");
        });
    }
  }
    /**
   * this function used to change status selected true or false for all data
   */
  public onSelectAllData(checked: boolean) {
    this.channelList = this.channelList.map(val => {
      val.selected = checked;
      return val;
    });
  }

  /**
     * this function used to get selected data from UI
     * @returns 
     */
  public getSelectedData(): any[] {
    let selectedData = [];
    if (this.channelList.length > 0) {
      for(let i of this.channelList.filter(val => val.selected))
      {
        selectedData.push(i.ID);
      }
    
    }
    return selectedData;
  }

  public onVerifyChannel(item: any) {
    this.channelService.verifyChannel(item.ID)
    .subscribe(response => {
      this.toastr.success("JWT Verified Successfully", "Success");
    });
  }
  public onLogin(item: any) {
    
    const loginUrl = `https://${item.SubDomain}/?UserName=${item.LoginID}&Password=${item.Password}`;

    window.open(loginUrl, '_blank');
    }
}

